import request from '@/config/axios'

export interface DigitalCardVO {
  id: number
  userId: number
  userNickname?: string
  userMobile?: string
  cardName?: string
  contentJson?: string
  whitelistFields?: string[]
  shareCode?: string
  status: number
  publishTime?: string | number
  version: number
  viewCount?: number
  shareCount?: number
  saveCount?: number
  theme?: string
  themeName?: string
  titleSecondary?: string
  attachmentsJson?: string
  isDefault?: boolean
  companyFieldsLocked?: boolean
  createTime?: string | number
  updateTime?: string | number
}

export interface DigitalCardDashboardVO {
  totalCards?: number
  publishedCards?: number
  draftCards?: number
  disabledCards?: number
  totalViews?: number
  totalShares?: number
  totalSaves?: number
  viewTop?: DigitalCardTopItemVO[]
  shareTop?: DigitalCardTopItemVO[]
  saveTop?: DigitalCardTopItemVO[]
}

export interface DigitalCardTopItemVO {
  cardId?: number
  userId?: number
  userNickname?: string
  cardName?: string
  metric?: number
}

export interface DigitalCardServiceConfigVO {
  ocrEnabled?: boolean
  ocrVendor?: string
  ocrDisabledTip?: string
  companyLookupEnabled?: boolean
  companyLookupVendor?: string
  companyLookupHideWhenDisabled?: boolean
  companyLookupDisabledTip?: string
  maxCardsPerUser?: number
}

/** 微名片 Admin API（路径仍挂 bosscircle，权限码兼容存量） */
export const getDigitalCardPage = (params: any) =>
  request.get({ url: '/bosscircle/digital-card/page', params })

export const getDigitalCard = (id: number) =>
  request.get<DigitalCardVO>({ url: '/bosscircle/digital-card/get', params: { id } })

export const auditDigitalCard = (data: { id: number; version: number; status: number }) =>
  request.put({ url: '/bosscircle/digital-card/audit', data })

export const updateDigitalCardCompanyLock = (data: { id: number; companyFieldsLocked: boolean }) =>
  request.put({ url: '/bosscircle/digital-card/company-lock', data })

export const getDigitalCardThemeConfig = () =>
  request.get({ url: '/bosscircle/digital-card/theme/config' })

export const saveDigitalCardThemeConfig = (data: { defaultTheme: string; themes: string[] }) =>
  request.put({ url: '/bosscircle/digital-card/theme/config', data })

export const batchOpenDigitalCard = (data: { userIds: number[]; autoPublish?: boolean }) =>
  request.post({ url: '/bosscircle/digital-card/batch-open', data })

export const getDigitalCardDashboard = () =>
  request.get<DigitalCardDashboardVO>({ url: '/bosscircle/digital-card/dashboard' })

export const getDigitalCardServiceConfig = () =>
  request.get<DigitalCardServiceConfigVO>({ url: '/bosscircle/digital-card/service-config' })

export interface DigitalCardThemeVO {
  id?: number
  themeKey: string
  name: string
  bgColor: string
  accentColor: string
  textColor: string
  borderColor?: string
  coverUrl?: string
  vertical?: boolean
  status?: number
  builtin?: boolean
  isDefault?: boolean
  sort?: number
}

export const getDigitalCardThemeList = () =>
  request.get<DigitalCardThemeVO[]>({ url: '/bosscircle/digital-card/theme/list' })

export const saveDigitalCardTheme = (data: Partial<DigitalCardThemeVO> & { name: string; bgColor: string; accentColor: string; textColor: string; setAsDefault?: boolean }) =>
  request.post<DigitalCardThemeVO>({ url: '/bosscircle/digital-card/theme/save', data })

export const setDigitalCardDefaultTheme = (id: number) =>
  request.put({ url: '/bosscircle/digital-card/theme/default', params: { id } })

export const updateDigitalCardThemeStatus = (id: number, status: number) =>
  request.put({ url: '/bosscircle/digital-card/theme/status', params: { id, status } })

export const deleteDigitalCardTheme = (id: number) =>
  request.delete({ url: '/bosscircle/digital-card/theme/delete', params: { id } })
